import React from 'react';

import { Header, Navbar } from '@C';
import ErrorBoundary from '@C/Error';
import { RouteSetup } from '@C/MyAccount';

const MyAccountPage = () => {
  return (
    <main>
      <div className="page-wrapper">
        <Header title="Credit Customers" />
        <Navbar />
        <div className="page-content">
          <section className="page-components">
            <div className="page-title">
              <h1> My Account</h1>
            </div>
            <ErrorBoundary>
              <RouteSetup />
            </ErrorBoundary>
          </section>
        </div>
      </div>
    </main>
  );
};

export { MyAccountPage };
